import {createCookie} from "./create-cookie.ts";
import {eraseCookie} from "./erase-cookie.ts";
import {readCookie} from "./read-cookie.ts";
import {CookieCategory} from "./types.ts";

/**
 * Check if cookies are enabled in the user's browser.
 *
 * @returns True if cookies are enabled, false otherwise.
 */
export function areCookiesEnabled(): boolean {
    createCookie(
        "detectCookiesEnabled",
        CookieCategory.StrictlyNecessary,
        "KhanAcademy",
    );
    if (readCookie("detectCookiesEnabled") == null) {
        return false;
    }
    eraseCookie("detectCookiesEnabled");
    return true;
}
